export default __webpack_public_path__ + "static/media/robo1.732b80a0.svg";